import UnitStruct from "@/redux/actions/struct/implemented/UnitStruct";
import classNames from "classnames";
import ListComponent from "../../../../../../configurable/components/ListComponent/ListComponent";
import i18n from "../../../../../../i18n";
import { AssetTypes } from "../../../../../../model/AssetTypes";
import BFButton from "../../../../../../modules/abstract-ui/general/Button/BFButton";
import LanguageService from "../../../../../../services/LanguageService";
import PermissionService from "../../../../../../services/PermissionService";
import { RAC_LIST_INVOICE_TYPES } from "../../../RACAppConstants";
import { RACInvoiceType } from "../../../RACInterfaces";
import "./RACInvoiceTypeList.scss";

interface RACInvoiceTypeListProps {
  onSelectInvoiceType: (invoiceType: RACInvoiceType) => void;
  selectedNode?: RACInvoiceType;
}

const RACInvoiceTypeList = (props: RACInvoiceTypeListProps) => {
  return (
    <div className={classNames("rac-invoice-type-list")}>
      <ListComponent
        emptyText={i18n.t(
          "rac:InvoiceType.EmptyText",
          "Keine Rechnungsarten vorhanden"
        )}
        additionalMatchQuery={{
          type: "and",
          query: [
            {
              type: "op",
              op: "in",
              name: "data.type",
              value: PermissionService.hasBusinessUnitRole(
                "invConf_invoiceType"
              ),
            },
          ],
        }}
        identifier={RAC_LIST_INVOICE_TYPES}
        dataUrl={`/api/asset/${AssetTypes.InvoiceConfig.InvoiceType}`}
        reloadOnMount={true}
        render={(node: RACInvoiceType, index, params) => {
          const isSelectedNode =
            props.selectedNode && node._id === props.selectedNode._id;
          const unitLabel =
            UnitStruct.getUnit(node.data.type)?.data.label || "";

          return (
            <div className={classNames("rac-invoice-type-list-entry")}>
              <BFButton
                className={classNames({
                  selected: isSelectedNode,
                })}
                onClick={() => {
                  if (props.onSelectInvoiceType) {
                    props.onSelectInvoiceType(node);
                  }
                }}
              >
                <div>
                  {LanguageService.translateLabel(node.data.displayName)}
                </div>
                <div> ({unitLabel}) </div>
              </BFButton>
            </div>
          );
        }}
      />
    </div>
  );
};

export default RACInvoiceTypeList;
